import React from 'react';

interface StatusTextProps {
  label: string;
  color: 'orange' | 'gray' | 'blue' | 'hyperlight20' | 'red' | 'primary';
  className?: string;
}

const StatusText: React.FC<StatusTextProps> = ({ color, label, className }) => {
  return <span className={`${className} status-text status-text__${color}`}>{label}</span>;
};

export default StatusText;
